"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.tab.instructions': 'Instrukcje',
    'trainer.tab.upload': 'Wgraj Dane',
    'trainer.tab.config': 'Konfiguruj Trening',
    'trainer.tab.training': 'Postęp Treningu',
    'trainer.tab.results': 'Wyniki',
};
